import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const removeShopManager = async (userId: number, domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shop-manager',
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            userId,
            domain
        },
        domain: domain
    });
}